import React, { FC } from 'react';
import classNames from 'classnames';

export const NavBarSidebar: FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <div className={classNames([className, 'tw-hidden tw-w-52 tw-mr-7 xl:tw-flex tw-items-center'])}>{children}</div>
);
